export default {
  id: 'rsrc.ShowEditor',
  name: 'Show Editor',
  matches: {
    client: ['rsrc.gallery.RsrcSelectedDialog'],
    objectType: 'rsrc',
    use: '!contextMenu'
  },
  handles: () => true,
  appearance: ({
    context
  }) => {
    const {
      editorVisible
    } = context;
    return {
      name: editorVisible ? 'Hide Editor' : 'Show Editor',
      icon: 'fa fa-fw fa-info-circle',
      checked: editorVisible,
      checkStyle: 'toggle'
    };
  },
  perform: async ({
    context
  }) => {
    const {
      onToggleEditor
    } = context;
    requestAnimationFrame(() => {
      onToggleEditor();
    });
  }
};